import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { isDefined } from '@sama/js-core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { EventTrackingService } from '../../../shared/event-tracking/event-tracking.service';
import { samplingPortalPath } from '../../../shared/misc-utilities/sampling-portal-paths';
import { UsersPerStep } from '../../../team-apis/otterdam/task';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';

@Component({
  selector: 'h3-sampling-controls',
  templateUrl: './sampling-controls.component.html',
  styleUrls: ['./sampling-controls.component.scss'],
  providers: [EventTrackingService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SamplingControlsComponent implements OnInit {
  @Input({ required: true }) pagePosition!: 'header' | 'footer';

  samplingHomeHref$: Observable<string>;
  submitters$: Observable<UsersPerStep | undefined>;

  constructor(
    private eventTrackingService: EventTrackingService,
    taskWorkspaceStore: TaskWorkspaceStore,
  ) {
    this.samplingHomeHref$ = taskWorkspaceStore('project').$.pipe(
      filter(isDefined),
      map((project) => samplingPortalPath(project.id)),
    );

    this.submitters$ = taskWorkspaceStore('task')('_extras')('submitters').$;
  }

  ngOnInit() {
    this.eventTrackingService.addContext({ page_position: this.pagePosition });
  }
}
